import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var paymentMethodMastercardIcon = /*#__PURE__*/React.createElement("svg", {
  height: "35",
  width: "56",
  viewBox: "0 0 56 35",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h56v35H0z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.96 6.09h13.943v22.775H20.959z",
  fill: "#FF5F00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.395 17.48a14.459 14.459 0 0 1 5.532-11.385C21.989 1.428 13.462 2.108 8.338 7.656c-5.124 5.549-5.124 14.103 0 19.651 5.124 5.549 13.651 6.229 19.589 1.562a14.459 14.459 0 0 1-5.532-11.39Z",
  fill: "#EB001B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.977 26.892v-.829h.201v-.171H49.7v.171h.19v.829h.088Zm.93 0v-1h-.146l-.168.714-.17-.714h-.144v1h.104v-.757l.157.65h.109l.157-.65v.757h.1Zm.453-9.412a14.483 14.483 0 0 1-23.433 11.385 14.483 14.483 0 0 0 0-22.774 14.483 14.483 0 0 1 23.434 11.385v.004Z",
  fill: "#F79E1B"
})), /*#__PURE__*/React.createElement("rect", {
  height: "34",
  width: "55",
  rx: ".75",
  stroke: "#D5D5D5",
  x: ".5",
  y: ".5"
})));

export { paymentMethodMastercardIcon as default };
//# sourceMappingURL=paymentMethodMastercardIcon.js.map
